import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

/**
 * Placeholder block for content that is still loading. Size and shape come
 * from classProps.root. The tint is translucent so themed (power branding)
 * backgrounds show through; a soft highlight sweeps across it unless the
 * user prefers reduced motion.
 */
export const Skeleton = ({ classProps }: PropsWithClassProps) => (
  <div aria-hidden="true" className={twMerge('relative overflow-hidden rounded bg-foreground/10', classProps?.root)}>
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent motion-reduce:hidden" />
  </div>
);
